// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__39ICq","actionsCol":"EnrolledClinics_actionsCol__3E2R1"};